import { render } from "./ScoreBoard.vue?vue&type=template&id=2d14bc40&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"

import "./ScoreBoard.vue?vue&type=style&index=0&id=2d14bc40&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d14bc40"]])

export default __exports__